<template>
    <div class="container">
        <div class="circle" :style="cssAttrs"></div>
        <div class="planet-name">{{ planet.toUpperCase() }}</div>
        <router-link class="link" :to="{ params: { planetId: planet } }" @click="closeDropdownMenu"><font-awesome-icon icon="fa-solid fa-angle-right" /></router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: ['planet'],
    inject: ['closeDropdownMenu'],
    computed: {
        ...mapGetters(['planetsData']),

        color() {
            return this.planetsData[this.planet].color
        },

        cssAttrs() {
            return {
                '--background-color': this.color
            }
        }
    }
    
}
</script>

<style scoped>
a.link {
    color: #838391;
}

.container {
    display: flex;
    height: 65px;
    padding: 25px;
}

.circle {
    background-color: var(--background-color);
    border-radius: 50%;
    height: 20px;
    width: 20px;
}

.planet-name {
    flex-grow: 1;
    color: "white";
    font-family: "Spartan", sans-serif;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 1.36px;
    line-height: 25px;
    padding-left: 25px;      
}

</style>